// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cYWd","colBig":"styles_colBig__2Vzxt","colSmall":"styles_colSmall__2Lbyg","shopifyNameWrapper":"styles_shopifyNameWrapper__1b7Sp"};